import i18n from '../../i18n/i18n';

// MUI Imports
import { Box, Typography } from '@mui/material';

// Helpers
import { useTheme } from '../../hooks/useTheme';
import { UserAccountInfo } from '../../types/userData';

interface CardAccountProps {
    account: UserAccountInfo;
    onClick?: () => void;
    selected?: boolean;
}

const InfoRow = ({ label, value }: { label: string; value: string | null }) => {
    const theme = useTheme();

    if (!value) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%'
            }}
        >
            <Typography
                sx={{
                    fontSize: '0.85em',
                    color: theme.palette.text.primary
                }}
            >
                {label}
            </Typography>
            <Typography
                sx={{
                    fontSize: '0.85em',
                    fontWeight: 'bold',
                    ml: 1,
                    color: theme.palette.secondary.main
                }}
            >
                {value}
            </Typography>
        </Box>
    );
};

const CardAccount = ({ account, onClick, selected = false }: CardAccountProps) => {
    const theme = useTheme();

    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2,
                border: selected ? `2px solid ${theme.palette.text.custom}` : 'none',
                borderRadius: '10px',
                width: '87%',
                backgroundColor: theme.palette.background.paper
            }}
        >
            <InfoRow label={i18n.t('AccountCard.group')} value={account.group} />
            <InfoRow label={i18n.t('AccountCard.organization')} value={account.organization} />
            <InfoRow label={i18n.t('AccountCard.profile')} value={account.profile} />
        </Box>
    );
};

export default CardAccount;
